<template>
  <div class="w-full flex flex-row justify-between p-2">
    <UUser
      :name="props.displayName"
      :description="props.position"
      :avatar="{
        src: '',
        loading: 'lazy',
        icon: 'i-somas-user-2',
        ui: {
          root: 'p-4 bg-secondary-100 border-1 border-secondary-200',
          icon: 'size-7 text-secondary-700',
        },
      }"
      :ui="{
        name: 'text-neutral-800 text-base font-medium leading-sm line-clamp-1',
        description:
          'text-neutral-400 text-xs font-medium leading-xs line-clamp-1',
      }"
    />
    <UDropdownMenu
      :items="items"
      :content="{
        align: 'start',
        side: 'bottom',
        sideOffset: 8,
      }"
      :ui="{
        content: 'w-34',
      }"
    >
      <UButton
        class="p-0"
        icon="i-somas-more-vertical"
        color="neutral"
        variant="link"
      />
    </UDropdownMenu>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  displayName?: string;
  position?: string;
}
const props = defineProps<Props>();

const items = ref([
  {
    label: "ข้อมูลส่วนตัว",
    to: { name: "auth-profile" },
  },
  {
    label: "ออกจากระบบ",
    to: { name: "auth-logout" },
  },
]);
</script>

<style></style>
